// Utility to load and register custom font for jsPDF

let fontLoadPromise = null;

/**
 * Fetches a font file and converts it to base64
 */
const fetchFontAsBase64 = async (url) => {
  const response = await fetch(url);
  const arrayBuffer = await response.arrayBuffer();
  const uint8Array = new Uint8Array(arrayBuffer);
  let binary = "";
  for (let i = 0; i < uint8Array.length; i++) {
    binary += String.fromCharCode(uint8Array[i]);
  }
  return btoa(binary);
};

/**
 * Loads Roboto font and registers it with jsPDF
 * Roboto has excellent Unicode support including Danish characters (æ, ø, å)
 * @param {jsPDF} doc - The jsPDF document instance
 */
export const loadExo2Font = async (doc) => {
  if (!fontLoadPromise) {
    fontLoadPromise = (async () => {
      try {
        // Using Roboto which has proper glyph width metrics for all Latin characters
        const regularUrl =
          "https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Me5Q.ttf";
        const boldUrl =
          "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlvAw.ttf";
        const italicUrl =
          "https://fonts.gstatic.com/s/roboto/v51/KFOKCnqEu92Fr1Mu53ZEC9_Vu3r1gIhOszmOClHrs6ljXfMMLoHQuAj-lg.ttf";
        const boldItalicUrl =
          "https://fonts.gstatic.com/s/roboto/v51/KFOKCnqEu92Fr1Mu53ZEC9_Vu3r1gIhOszmOClHrs6ljXfMMLmbXuAj-lg.ttf";

        const [regularBase64, boldBase64, italicBase64, boldItalicBase64] =
          await Promise.all([
            fetchFontAsBase64(regularUrl),
            fetchFontAsBase64(boldUrl),
            fetchFontAsBase64(italicUrl),
            fetchFontAsBase64(boldItalicUrl),
          ]);

        return { regularBase64, boldBase64, italicBase64, boldItalicBase64 };
      } catch (error) {
        console.error("Failed to load font:", error);
        return null;
      }
    })();
  }

  const fonts = await fontLoadPromise;

  if (fonts) {
    // Register the fonts with jsPDF using "Exo2" name for compatibility
    doc.addFileToVFS("Roboto-Regular.ttf", fonts.regularBase64);
    doc.addFileToVFS("Roboto-Bold.ttf", fonts.boldBase64);
    doc.addFont("Roboto-Regular.ttf", "Exo2", "normal");
    doc.addFont("Roboto-Bold.ttf", "Exo2", "bold");
    doc.addFileToVFS("Roboto-Italic.ttf", fonts.italicBase64);
    doc.addFileToVFS("Roboto-BoldItalic.ttf", fonts.boldItalicBase64);
    doc.addFont("Roboto-Italic.ttf", "Exo2", "italic");
    doc.addFont("Roboto-BoldItalic.ttf", "Exo2", "bolditalic");
    return true;
  }

  return false;
};
